import { createAsyncIcon } from '../../_factory/createAsyncIcon';

const AsyncMaterialIconRounded = createAsyncIcon(() => import('./MaterialIconRounded'));

export default AsyncMaterialIconRounded;

AsyncMaterialIconRounded.displayName = 'AsyncMaterialIconRounded';
